export default "__VITE_ASSET__e18edd49__"